<template>
  <div class="property-banner">
    <img :src="propertyBanner" alt="" />
    <div class="absolute">
      <div class="title">物业APP</div>
      <div class="text">
        一机在手，满足物业在线协同管理，实现物业服务模式升级，助力物业智能化，提升业主满意度，构建智慧社区。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import propertyBanner from "../../../../assets/product/propertyBanner.png";

export default {
  setup() {
    return reactive({
      propertyBanner: propertyBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.property-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .property-banner {
    min-width: 1180px;
  }
}
.property-banner img {
  width: 100%;
  height: 628px;
}
.absolute {
  position: absolute;
  top: 30%;
  left: 33%;
  transform: translate(-50%, -50%);
}
.absolute .title {
  font-size: 30px;
  color: #fff;
}
.absolute .text {
  width: 490px;
  font-size: 14px;
  margin-top: 30px;
  color: #fff;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #fff;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #fff;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
